// custom scripts

function favProduct() {
  
  if (this.classList.contains("favorited")) {
    triggerToast("Von deiner <u>Wunschliste</u> entfernt.", this.getAttribute("data-imageUrl"));
    this.classList.remove("favorited");
    removeValueFromCookie(this.getAttribute("data-productId"));
    removeWishlistItem(this.getAttribute("data-productId"));
  } else {
    if (getCookieValue('favoritedProducts') == null || getCookieValue('favoritedProducts') == '') {
    	document.getElementById('added-to-wishlist-mail').classList.add("slide-right");
    } else {
    	triggerToast("Zu deiner <u>Wunschliste</u> hinzugefügt.", this.getAttribute("data-imageUrl"));
    }
    this.classList.add("favorited");
    addValueToCookie(this.getAttribute("data-productId"));
    addWishlistItem(
      this.getAttribute("data-productId"),
      this.getAttribute("data-productTitle"),
      this.getAttribute("data-productUrl"),
      this.getAttribute("data-imageUrl")
    );
  }
  
  document.getElementById('fav-count').innerHTML = countProducts();
}

  document.addEventListener('DOMContentLoaded', function() {
    
    const boxes = document.querySelectorAll('.favProduct');
    boxes.forEach(box => {
      box.addEventListener('click', favProduct);
    });
    
    document.getElementById('fav-count').innerHTML = countProducts();
  });
  
  function triggerToast(toast_text, imageurl) {
    
    var toast = document.querySelector('.toast-desktop-wrapper');
    if (toast != null) {
      toast.classList.add("toast-desktop-wrapper--shown");
    }
    setTimeout(function() {
      toast.classList.remove("toast-desktop-wrapper--shown");
    }, 3000)
  
    var toast_image = document.querySelector('.toast-desktop__image');
    var toast_text_div = document.querySelector('.toast-desktop__info div');
    if (toast != null) {
      toast.classList.add("toast-desktop-wrapper--shown");
    }
    toast_image.src = imageurl;
    toast_text_div.innerHTML = toast_text;
  
  
  }
  
  function addValueToCookie(value) {
    myArray = getCookieValue('favoritedProducts').split(",");
      console.log('myArray', myArray);
    var index = myArray.indexOf(value);
    if (index !== -1) {
      myArray.splice(index, 1);
    }
    myArray.push(value);
  
    const cookieName = "favoritedProducts";
    const cookieValue = myArray.join(',');
    const daysToExpire = new Date(2147483647 * 1000).toUTCString();
    document.cookie = cookieName + '=' + cookieValue + '; expires=' + daysToExpire + ';path=/;domain=heybalu.com';
  }
  
  function removeValueFromCookie(value) {
    myArray = getCookieValue('favoritedProducts').split(",");
    var index = myArray.indexOf(value);
    if (index !== -1) {
      myArray.splice(index, 1);
    }
  
    const cookieName = "favoritedProducts";
    const cookieValue = myArray.join(',');
    const daysToExpire = new Date(2147483647 * 1000).toUTCString();
    document.cookie = cookieName + '=' + cookieValue + '; expires=' + daysToExpire + ';path=/;domain=heybalu.com';
  }
  
  const getCookieValue = (name) => (
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  )
  
  // function initializeFavoritedProducts() {
  //   if (getCookieValue('favoritedProducts') == null) {
  //     return;
  //   }
  //   myArray = getCookieValue('favoritedProducts').split(",");
  //   myArray.forEach((favedProduct, index) => {
  //     if (favedProduct != "") {
       
  //       var favelements = document.querySelectorAll(`span[data-productid="${favedProduct}"]`);
  //       favelements.forEach(favelement => {
  //         if (favelement != null) {
  //           favelement.classList.add("favorited");
  //         }
  //       });
     
  //     }
  //   });
  // }
  // initializeFavoritedProducts();

  function initializeFavoritedProducts() {
    if (getCookieValue('favoritedProducts') == null) {
      return;
    }
    myArray = getCookieValue('favoritedProducts').split(",");
    myArray.forEach((favedProduct, index) => {
      if (favedProduct != "") {
        var favelements = document.querySelectorAll('[data-productid="' + favedProduct + '"]');
        favelements.forEach(favelement => {
          if (favelement != null) {
            favelement.classList.add("favorited");
          }
        });
      }
    });
  }
  initializeFavoritedProducts();
  
  function countProducts() {
    if (getCookieValue('favoritedProducts') == null || getCookieValue('favoritedProducts') == '') {
      return null;
    }
    return getCookieValue('favoritedProducts').split(",").length - 1;
  }
  
  function httpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open("GET", theUrl, false); // false for synchronous request
    xmlHttp.send(null);
    return xmlHttp.responseText;
  }
  
  function generateWishlistId(theUrl) {
    var xhr = new XMLHttpRequest();
    var url = theUrl;
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 201) {
        var json = JSON.parse(xhr.responseText);
        const cookieName = "wishlistId";
        const cookieValue = json.id;
        const daysToExpire = new Date(2147483647 * 1000).toUTCString();
        document.cookie = cookieName + '=' + cookieValue + '; expires=' + daysToExpire + ';path=/;domain=heybalu.com';
        return getCookieValue('wishlistId');
      }
    };
    var data = JSON.stringify({});
    xhr.send(data);
  }
  
  function getWishlistId() {
    if (getCookieValue('wishlistId') !== null && getCookieValue('wishlistId') != '') {
      return getCookieValue('wishlistId');
    }
    const cookieName = "wishlistId";
    const cookieValue = "generating";
    const daysToExpire = new Date(2147483647 * 1000).toUTCString();
    document.cookie = cookieName + '=' + cookieValue + '; expires=' + daysToExpire + ';path=/;domain=heybalu.com';
    generateWishlistId('https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/wishlists.php');
    return null;
  }
  
  function addWishlistItem(productid, product_title, product_url, image_url) {
    
    if (getWishlistId() == null || getWishlistId() == "generating") {
      setTimeout(function() {
        addWishlistItem(productid, product_title, product_url, image_url);
      }, 200);
      return;
    }
    
    var xhr = new XMLHttpRequest();
    var url = "https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/add_wishlist_item.php?id=" + getWishlistId();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 201) {
        var json = JSON.parse(xhr.responseText);
      }
    };
    var data = JSON.stringify({
      "productid": parseInt(productid),
      "product_title": product_title,
      "product_url": product_url,
      "image_url": image_url
    });
    xhr.send(data);
  }
  
  function removeWishlistItem(productid) {
    if (getWishlistId() == null) {
      return;
    }
    var xhr = new XMLHttpRequest();
    var url = "https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/remove_wishlist_item.php?id=" + getWishlistId() + "/" + productid;
    xhr.open("DELETE", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 201) {
        var json = JSON.parse(xhr.responseText);
      }
    };
    var data = JSON.stringify({});
    xhr.send(data);
  }

  document.addEventListener('DOMContentLoaded', function() {
      // Wait for 1 second after body is ready
      setTimeout(function() {
        // Check if the body has class teeinblue-enabled
        if(document.body.classList.contains('teeinblue-enabled')) {
            // Select the div with class .shipping_usp
            var shippingUspDiv = document.querySelector('.shipping_usp');
            // Select the target div with ID #teeFormActions
            var targetDiv = document.querySelector('#teeFormActions');

            // If both divs exist, append the .shipping_usp div to the end of #teeFormActions
            if(shippingUspDiv && targetDiv) {
                targetDiv.appendChild(shippingUspDiv);
            }
        }
      }, 1000); // 1000ms = 1 second
  });

  function addMailToWishlist() {
    
    var xhr = new XMLHttpRequest();
    var url = "https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/add_mail.php?id=" + getWishlistId();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 201) {
        var json = JSON.parse(xhr.responseText);
      }
    };
    var data = JSON.stringify({
      "mail": document.getElementById('email_wishlist').value
    });
    xhr.send(data);
    document.getElementById('added-to-wishlist-mail').classList.remove("slide-right");
  }
  function continueWithout(e){
    document.getElementById('added-to-wishlist-mail').classList.remove("slide-right");
    e = e || window.event;
    e.preventDefault();
  }
  // page js
  function removeElement(id) {
    var elem = document.getElementById(id);
    return elem.parentNode.removeChild(elem);
  }

  function findGetParameter(parameterName) {
    var result = null,
      tmp = [];
    location.search
      .substr(1)
      .split("&")
      .forEach(function(item) {
        tmp = item.split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });
    return result;
  }

  document.addEventListener('DOMContentLoaded', function() {
document.getElementById('fav-count').innerHTML = countProducts();
    if(document.getElementById('wa-link')){
    document.getElementById('wa-link').href = "https://wa.me/?text=Schau%20mal%2C%20das%20ist%20meine%20Wunschliste%20von%20heybalu.com%20mit%20meinen%20Lieblingspostern%3A%20" + encodeURIComponent("https://heybalu.com/pages/wunschliste?ref=" + getCookieValue('wishlistId'));
    }
    if (document.getElementById('fb-link')){
      document.getElementById('fb-link').href = "fb-messenger://share/?link=" + encodeURIComponent("https://heybalu.com/pages/wunschliste?ref=" + getCookieValue('wishlistId'));
    }
    var url = null;
    if (getCookieValue('wishlistId') !== null && getCookieValue('wishlistId') != '') {
      url = "https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/wishlist.php?id=" + getCookieValue('wishlistId');
    }

    if (findGetParameter("ref") != null) {
      url = "https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/wishlist.php?id=" + findGetParameter("ref");

      var elem = document.getElementById('sharewishlist');
      elem.parentNode.removeChild(elem);
    }
    if (url !== null) {
      
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.setRequestHeader("Accept", "application/json");
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
          var json = JSON.parse(xhr.responseText);
         
          document.getElementById("wishlist").innerHTML = "";
          json.forEach(element => {
            var template =
              `
                  <product-card class="product-card product_wishlist_set" id="product-##PRODUCTID##">
                    <div class="product-card__figure">
                      <a href="##PRODUCTURL##" class="product-card__media">
                        <img src="##IMAGEURL##" height="" width=""/>
                      </a>
                      <span class="wishlist-tooltip favProduct favorited" data-productid="##PRODUCTID##" data-producttitle="##PRODUCTNAME##" data-producturl="##PRODUCTURL##" data-imageurl="##IMAGEURL##">
                        <i class="i-wishlist i-wishlist--add"></i>
                      </span>
                      <div class="product-card__info empty:hidden">
                        <div class="product-title product-card__title bold">##PRODUCTNAME##</div>
                      </div>
                    </div>
                  </product-card>`;
            template = template.replace('##PRODUCTURL##', element.product_url);
            template = template.replace('##PRODUCTURL##', element.product_url);
            template = template.replace('##IMAGEURL##', element.image_url);
            template = template.replace('##IMAGEURL##', element.image_url);
            template = template.replace('##PRODUCTNAME##', element.product_title);
            template = template.replace('##PRODUCTNAME##', element.product_title);
            template = template.replace('##PRODUCTID##', element.product_id);
            template = template.replace('##PRODUCTID##', element.product_id);
            document.getElementById("wishlist").innerHTML = document.getElementById("wishlist").innerHTML + template;

          });

          const boxes = document.querySelectorAll('.favProduct');

          if (findGetParameter("ref") == null) {
            boxes.forEach(box => {
              box.addEventListener('click', favProduct);
            });
          } else {

            boxes.forEach(box => {
              box.parentNode.removeChild(box);
            });
          }
        }
        if (xhr.status === 404) {
          document.getElementById("wishlist").innerHTML = '<div style="text-align:center">Deine Wunschliste ist leer.</div>';
          var elem = document.getElementById('sharewishlist');
          elem.parentNode.removeChild(elem);

        }
      };
      var data = JSON.stringify({});
      xhr.send(data);
    }

  });

  function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
     
    } catch (err) {
      
    }

    document.body.removeChild(textArea);
  }

  function copyTextToClipboard(e, text) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
      
    }, function(err) {
      
    });
    e = e || window.event;
    e.preventDefault();
  }


// append payment icons
setTimeout(function() {
  if (document.body.classList.contains('teeinblue-enabled')) {
    const shippingUsp = document.querySelector('#teeFormActions');
    const paymentIcons = document.querySelector('.payments-product-icons');

    if (shippingUsp && paymentIcons) {
      shippingUsp.insertAdjacentElement('afterend', paymentIcons);
    }
  }
}, 2000);

// Re-render Monkfish product-review badges wherever product cards arrive after page load.
// Monkfish (collection-reviews.min.js) only populates .shopify-product-reviews-badge spans on
// DOMContentLoaded and on "recommendations:loaded", so any card swapped in later keeps an empty
// badge and ends up without the star rating every other card on the shop shows.
//
// Two places swap cards in:
//
//   1. The collection/search section. Collections use facet:update to replaceChildren() the whole
//      section on paging and filtering. The search page's live results render into
//      #hb-page-search-results, which sits inside that same section, so one observer covers both.
//   2. The search drawer. Its predictive-search element fetches search/suggest and swaps the cards
//      into [slot="results"]. The drawer lives in the header, a different section, which is why it
//      was missed: its results showed no stars at all while the results page showed them.
//
// fetchAndDisplayCollectionReviews only handles badges without .vrs-processed-snippet, and it
// marks every badge it touches (including ones with no reviews), so re-calling it is idempotent
// and the observer settles instead of looping on its own mutations.
document.addEventListener('DOMContentLoaded', function () {
  var roots = [];

  var results = document.querySelector('.collection__results');
  var section = results ? results.closest('.shopify-section') : null;
  if (section) roots.push(section);

  var drawer = document.getElementById('search-drawer');
  if (drawer) roots.push(drawer);

  if (!roots.length) return;

  function reloadCollectionReviews() {
    if (typeof window.fetchAndDisplayCollectionReviews === 'function') {
      window.fetchAndDisplayCollectionReviews();
    } else {
      // Fallback: Monkfish also listens for this event.
      document.dispatchEvent(new Event('recommendations:loaded'));
    }
  }

  var debounce = null;
  var observer = new MutationObserver(function () {
    var pending = roots.some(function (root) {
      return root.querySelector('.shopify-product-reviews-badge:not(.vrs-processed-snippet)');
    });

    if (pending) {
      clearTimeout(debounce);
      debounce = setTimeout(reloadCollectionReviews, 200);
    }
  });

  roots.forEach(function (root) {
    observer.observe(root, { childList: true, subtree: true });
  });
});

  
// Show the exact review count on product cards.
//
// Monkfish serves collection badges from getBatch.php, which caps total_reviews at the string
// "100+" — and collection-reviews.min.js writes that value into the badge verbatim. So every
// popular product reads "(100+)" on collection, search and recommendation cards, while its own
// PDP shows the real number, because the PDP is fed by get.php instead.
//
// get.php returns the exact figure but only handles one product per call, so only badges that
// actually came back capped are topped up — roughly 3% of the catalogue, typically zero or one
// request per collection page. Results are cached for the session.
//
// This is a stopgap: the real fix is removing the cap in getBatch.php. It also does not help
// crawlers, since the count still arrives via JavaScript.
(function () {
  var REVIEWS_API = 'https://monkfish-app-6yhq2.ondigitalocean.app/reviews/get.php';
  var CACHE_KEY = 'hb-exact-review-counts';
  var DONE_CLASS = 'hb-count-exact';
  var inFlight = {};

  function readCache() {
    try {
      return JSON.parse(sessionStorage.getItem(CACHE_KEY)) || {};
    } catch (error) {
      return {};
    }
  }

  function writeCache(cache) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    } catch (error) {
      // Private mode or a full quota — the badge just stays as Monkfish left it.
    }
  }

  // Mirrors generateCollectionStarHtml in collection-reviews.min.js, so a corrected badge keeps
  // the same markup and CSS as an untouched one.
  function starHtml(rating) {
    var value = Math.max(0, Math.min(5, rating || 0));
    var html = '';

    for (var index = 0; index < 5; index++) {
      var remainder = value - index;
      var fill = '0';

      if (remainder >= 0.875) fill = '100';
      else if (remainder >= 0.625) fill = '75';
      else if (remainder >= 0.375) fill = '50';
      else if (remainder >= 0.125) fill = '25';

      html += '<i aria-hidden="true" class="ruk-icon-percentage-star--' + fill + '"></i>';
    }

    return html;
  }

  function applyExactCount(badge, data) {
    if (!data || data.total_reviews === null || data.total_reviews === undefined) return;

    var summary = badge.querySelector('.vrs-rating-summary');
    var countElement = badge.querySelector('.ruk-rating-snippet-count');
    if (!summary || !countElement) return;

    countElement.textContent = '(' + data.total_reviews + ')';

    // Take the average from the same response as the count. getBatch.php and get.php disagree
    // slightly, and matching the PDP is what a shopper comparing the two pages will notice.
    if (data.average_rating !== null && data.average_rating !== undefined) {
      Array.prototype.forEach.call(summary.querySelectorAll('i'), function (star) {
        star.remove();
      });
      summary.insertAdjacentHTML('afterbegin', starHtml(parseFloat(data.average_rating)));
    }
  }

  function fetchExact(productId) {
    if (inFlight[productId]) return inFlight[productId];

    var language = document.documentElement.lang || 'de';
    var url = REVIEWS_API + '?product_id=' + encodeURIComponent(productId) +
      '&language=' + encodeURIComponent(language);

    inFlight[productId] = fetch(url)
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (!data) return null;

        var slim = { total_reviews: data.total_reviews, average_rating: data.average_rating };
        var cache = readCache();
        cache[productId] = slim;
        writeCache(cache);
        return slim;
      })
      .catch(function () {
        return null;
      });

    return inFlight[productId];
  }

  function correctCappedBadges() {
    var badges = document.querySelectorAll(
      '.shopify-product-reviews-badge.vrs-processed-snippet:not(.' + DONE_CLASS + ')'
    );
    if (!badges.length) return;

    var cache = readCache();

    Array.prototype.forEach.call(badges, function (badge) {
      var countElement = badge.querySelector('.ruk-rating-snippet-count');
      if (!countElement) return;

      // Claim the badge before any async work so a second observer pass cannot queue it twice.
      badge.classList.add(DONE_CLASS);

      if (countElement.textContent.indexOf('+') === -1) return;

      var productId = badge.dataset.id;
      if (!productId) return;

      if (cache[productId]) {
        applyExactCount(badge, cache[productId]);
        return;
      }

      fetchExact(productId).then(function (data) {
        applyExactCount(badge, data);
      });
    });
  }

  var debounce = null;
  function scheduleCorrection() {
    clearTimeout(debounce);
    debounce = setTimeout(correctCappedBadges, 250);
  }

  document.addEventListener('DOMContentLoaded', scheduleCorrection);
  document.addEventListener('recommendations:loaded', scheduleCorrection);

  // Monkfish populates badges after its own DOMContentLoaded handler, and AJAX paging swaps in
  // fresh cards later, so watch for badges it has just marked as processed.
  new MutationObserver(scheduleCorrection).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();
